<template>
  <div class="row full-width full-height"
    oncontextmenu="return false"
    @dragenter="listen__x__ondragenter"
    @dragleave="listen__x__ondragleave"
    @dragover="listen__x__ondragover"
    @drop="listen__x__ondrop"
    >
  
    <div class="full-height">
      <sample-image-list
        :images="sampleImages"
        @jobstart="showLayer"
        @joberror="(param) => listen__x__onfileerror(param)"
        @jobdone="(file) => preprocessingFile(file)"
      />  
    </div>

    <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">

      
      <div style="flex:0 0 40px">
        <div class="row" style="padding-bottom: 6px;">
          <div class="row text-h6">
            {{title}}
            <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;"/>
          </div>
          <q-space />
          <div class="row text-caption" style="align-items:center">
            <health-check-widget
              ref="health-check"
              :functionKey="recognitionType"
              :functionCheck="healthCheckFunction"
            />
          </div>
        </div>
      </div>
    
      <div style="flex:0 0 15px;" />
    
      <div class="column col bg-white shadow-1 full-width">
        <div class="bg-primary" style="padding:10px 10px;">
          <q-file dark color="white" ref="file" label="파일 업로드..." v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile">
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>
        <q-separator />
        <q-toolbar>
          <q-btn-group class="image-tool-btn-group" unelevated dense>
            <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
            <q-separator vertical />
            <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
            <q-separator vertical />
            <q-btn unelevated color="primary" icon="settings" label="옵션" dense no-caps @click="state.dialogOptions.show = true" style="padding:0px 5px;" />
            <q-separator vertical />
            <q-btn unelevated color="primary" icon="file_download" label="인식결과 다운로드" :disable="frameData1._empty == true" dense no-caps @click="listen__result__download" style="padding:0px 5px;" />
          </q-btn-group>
          <q-space />
          <q-tabs
            v-model="state.tab"
            indicator-color="primary"
            inline-label
            shrink stretch
          >
            <q-tab name="image" icon="image" label="인식결과(Image)" />
            <q-tab name="text" icon="list_alt" label="인식결과(Text)">
            </q-tab>
            <q-tab name="json" icon="account_tree" label="Json" v-show="isDev"/>
          </q-tabs>
        </q-toolbar>
        <q-separator />
        <div class="row col full-height full-width">
          <div class="row col full-height full-width">
            <image-view
              ref="image-view1"
              :frame-data="frameData1"
              :pred="pred"
              class="col full-height full-width"
              :passive="false"
              :initial-tool-option="state.currentFrameToolOption"
              :messages-upload="['\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']"
              @onstatechange="listen__image_view__onstatechange" />
          </div>
    
          <div class="row col full-height full-width" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
            <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
              <q-tab-panel name="image" class="full-height full-width" style="padding:0;">
                <image-view
                  ref="image-view2"
                  :frame-data="frameData2"
                  :pred="pred"
                  class="col full-height full-width"
                  :passive="false"
                  :initialFrameState="state.currentFrameState"
                  :initial-tool-option="state.currentFrameToolOption"
                  @onstatechange="listen__image_view__onstatechange2" />
              </q-tab-panel>
              <q-tab-panel name="text" style="overflow-x:hidden">
                <q-input label="검색..." dense v-model="state.searchText" debounce="300">
                  <template v-slot:prepend>
                    <q-icon name="search"/>
                  </template>
                  <template v-slot:append>
                    <q-icon name="close" @click="state.searchText = ''" class="cursor-pointer" />
                  </template>
                </q-input>
    
                <div style="height:15px;" />
    
                <div>
                  <div style="display:flex;align-items:center;" v-show="isDev">
                    <q-icon name="content_cut" size="xs" />
                    <span style="margin-left:3px;margin-right:8px;">Threshold Probability</span>
                    <input type="checkbox" v-model="state.slider.thresholdProbability.active" />
                  </div>
                  <q-slider
                    class="q-mt-xl slider-theshold-probability"
                    v-model="state.slider.thresholdProbability.value"
                    :label-value="sliderThresholdProbabilityValue"
                    :color="state.slider.thresholdProbability.active ? 'primary' : 'blue-4'"
                    :label-always="state.slider.thresholdProbability.active"
                    markers
                    marker-labels
                    switch-label-side
                    switch-marker-labels-side
                    :min="0"
                    :max="1"
                    :step="0"
                    dense
                    style="padding:0px 0px 0px 15px"
                    v-show="isDev"
                  >
                    <template v-slot:marker-label-group>
                      <div
                        v-for="(marker, index) in [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]"
                        :key="index"
                        class="q-slider__marker-labels q-slider__marker-labels--h-standard q-slider__marker-labels--h-ltr"
                        style="color:#AAAAAA;font-size:11px;"
                        :style="{left: `${index * 10}%`}"
                      >{{ marker }}</div>
                    </template>
                  </q-slider>
                </div>
    
                <div style="height:45px;" />
                <q-separator />
                <div style="height:10px;" />
    
                <transition-group
                  name="staggered-fade"
                  tag="div"
                  class="text-area"
                  style="flex:1 0 0;"
                  v-bind:css="true"
                  v-on:before-enter="beforeEnter"
                  v-on:enter="enter"
                  v-on:leave="leave"
                >
                  <BadgeText v-for="text in searchTexts" :data="text" :key="text.id" @ontoggle="listen__badge__ontoggle" />
                </transition-group>
              </q-tab-panel>
              <q-tab-panel name="json">
                <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
              </q-tab-panel>
            </q-tab-panels>
          </div>
        </div>
      </div>
    </div>

    <q-dialog v-model="state.dialogOptions.show">
      <q-card style="width: 300px" class="q-px-sm q-pb-md">
        <q-card-section>
          <div class="text-h6">옵션</div>
        </q-card-section>
  
        <q-item-label header>문자영역 선 색</q-item-label>
        <q-item class="row" dense>
          <div class="row col" style="align-items:center;">
            <div :style="{background: state.currentFrameToolOption.lineColor}" style="width:16px;height:16px;border:1px solid black" />
            <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineColor }}</span>
          </div>
          <div class="row col" style="align-items:center;justify-content:flex-end">
            <q-btn-dropdown
              color="primary"
              unelevated
              no-caps
              dense
              label="변경"
              style="padding:0px 10px;"
            >
              <q-color :model-value="state.currentFrameToolOption.lineColor" @change="val => {state.currentFrameToolOption.lineColor = val}" :default-value="state.currentFrameToolOption.lineColor"  class="my-picker" />
            </q-btn-dropdown>
          </div>
        </q-item>
        <div style="height:10px;" />
        <q-item-label header><b>선택된</b> 문자영역 색</q-item-label>
        <q-item class="row" dense>
          <div class="row col" style="align-items:center;">
            <div :style="{background: state.currentFrameToolOption.lineHighlightColor}" style="width:16px;height:16px;border:1px solid black" />
            <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineHighlightColor }}</span>
          </div>
          <div class="row col" style="align-items:center;justify-content:flex-end">
            <q-btn-dropdown
              color="primary"
              unelevated
              no-caps
              dense
              label="변경"
              style="padding:0px 10px;"
            >
              <q-color :model-value="state.currentFrameToolOption.lineHighlightColor" @change="val => {state.currentFrameToolOption.lineHighlightColor = val}" :default-value="state.currentFrameToolOption.lineHighlightColor"  class="my-picker" />
            </q-btn-dropdown>
          </div>
        </q-item>
        <div style="height:10px;" />
        <q-item-label header>문자영역 선 두께</q-item-label>
        <q-item class="row" dense>
          <div class="row" style="align-items:center;flex:0 0 50px;">
            <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
          </div>
          <div class="row col" style="align-items:center;justify-content:flex-end">
            <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
          </div>
        </q-item>
      </q-card>
    </q-dialog>
  
    <q-dialog v-model="state.dialogHelp">
      <q-card v-if="recognitionType == 'ocr'">
        <q-card-section>
          <div class="text-h6">{{title}}</div>
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          범용 OCR
          <br />
          간판, 메뉴판, 인쇄물 등 특정 범주에 국한되지 않고 다양한 형태와 환경의 글자를 인식 할 수 있습니다.
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
          없음
        </q-card-section>
  
        <q-card-section class="q-pt-none" v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
          Johan
        </q-card-section>
  
        <q-card-section class="q-pt-none" v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
          {{getAddress()}}
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
          <ul style="margin:0">
            <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_detector\PaddleOCR\ch_ppocr_server_v2.0_det.pb <i style="color:red">(46.7 MB)</i></li>
            <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_recognizer\SelvyOCR\generic_none_resnet_lstm_ctc.pb <i style="color:red">(182 MB)</i></li>
          </ul>
        </q-card-section>
  
        <q-card-actions align="right">
          <q-btn flat label="확인" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
      
      <q-card v-if="recognitionType == 'hwr'">
        <q-card-section>
          <div class="text-h6">{{title}}</div>
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          손으로 필기한 이미지에 특화된 OCR입니다. 한국어, 영어, 숫자를 인식할 수 있습니다.
        </q-card-section>
  
        <q-card-section class="q-pt-none" v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
          없음
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
          Sheldon
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
          {{getAddress()}}
        </q-card-section>
  
        <q-card-actions align="right">
          <q-btn flat label="확인" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
  
      <q-card v-if="recognitionType == 'ocr-doc'">
        <q-card-section>
          <div class="text-h6">{{title}}</div>
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          문서(A4-좁게,넓게) 이미지에 특화된 OCR입니다.
          배경보다 전경(글자)가 어두운 경우 인식이 잘 됩니다.
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
          <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=177704088">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=177704088</a>
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
          Johan
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
          {{getAddress()}}
        </q-card-section>
  
        <q-card-section class="q-pt-none"  v-show="isDev">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
          <ul style="margin:0">
            <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_detector\jijo\run12.pb <i style="color:red">(7.21 MB)</i></li>
            <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_recognizer\SelvyOCR\run13.pb <i style="color:red">(8.00 MB)</i></li>
          </ul>
        </q-card-section>
  
        <q-card-actions align="right">
          <q-btn flat label="확인" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  
    <q-inner-loading :showing="state.loadingLayer.show">
      <q-spinner-facebook
          color="primary"
          size="2em"
        />
      {{ state.loadingLayer.message }}
    </q-inner-loading>
  
    <q-inner-loading :showing="compositionDropData.counterDrag > 0">
      <div class="text-h3">드롭하세요.</div>
    </q-inner-loading>
  
    <image-processing-dialog ref="image-processing-dialog"
      @done="listen__ip_dialog__done"
    />
  </div>
  </template>
  
  <script>
  
  import compositionDrop from '@/composition/drop.js'
  import compositionFile from '@/composition/file.js'
  
  import MixinLayer from '@/mixins/layer.js'
  
  import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
  import SampleImageList from '@/components/SampleImageList2.vue'
  import ImageView from '@/projects/ocr/views/ImageView.vue'
  import BadgeText from '@/projects/ocr/components/BadgeText.vue'
  import HealthCheckWidget from '@/components/healthCheckWidget.vue'
  
  import Velocity from 'velocity-animate'
  
  import MISC from '@/js/miscellaneous.js'
  import PARSE from '@/js/parse.js'
  import recognize from '@/js/recognize.js'
  import ETC from '@/js/etc.js'
  
  import {getCurrentInstance} from '@vue/composition-api'
  
  export default {
    setup () {
      const vm = getCurrentInstance()
      if (null == vm ) {
        return {}
      }
      const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
      function preprocessingFile(data) {
        const file = data instanceof File ? data : data.file
        return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
      }
      const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
      return {
        compositionDropData,
        listen__x__ondragenter,
        listen__x__ondragleave,
        listen__x__ondragover,
        listen__x__ondrop,
        compositionDrop,
        compositionFileData,
        preprocessingFile
      }
    },
    mixins: [MixinLayer],
    props: ['recognition-type'],
    data: function () {
      return {
        state: {
          dialogHelp: false,
          dialogOptions: {
            show: false
          },
          fitToWindow: false,
          searchText: null,
          tab: 'text',
          currentFrameState: {
            coord: {
              x: 0,
              y: 0
            },
            zoom: undefined,
            voi: {
              windowCenter: 127,
              windowWidth: 256
            }
          },
          currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2, lineColor: '#ffff00', lineHighlightColor: '#ff0000'},
          slider: {
            thresholdProbability: {
              value: 0.5,
              active: false
            }
          }
        },
        sampleImages: [],
        frameData1: {
          _uid: MISC.getUuid4(),
          _empty: true
        },
        frameData2: {
          _uid: MISC.getUuid4(),
          _empty: true
        },
        pred: [],
        jsonData: [],
        predJpegImage: null,
      }
    },
    components: {
      ImageProcessingDialog,
      SampleImageList,
      ImageView,
      BadgeText,
      HealthCheckWidget
    },
    methods: {
      listen__badge__ontoggle: async function (e) {
        const Vue = this
        Vue.state.slider.thresholdProbability.active = false
  
        await (async () => {})()
  
        for (let item of Vue.pred) {
          if (item.id == e.id) {
            item.highlight = !item.highlight;
          }
        }
  
        Vue.updateTagging()
      },
      listen__x__onfilechange: function (file, options) {
        if (this.recognitionType == 'hwr')
          this.recognitionHwr(file, options)
        else if (this.recognitionType == 'ocr')
          this.recognitionOcr(file, options)
        else
          this.recognitionOcrDocument(file, options)
      },
      listen__x__onfileerror: function (param) {
        const Vue = this
  
        Vue.jsonData = []
        Vue.compositionFileData.files = []
        Vue.clearData()
        Vue.hidingLayer()
  
        let color = param.color
        if (color == undefined)
          color = 'black'
  
        Vue.$q.notify({
          message: param.message,
          icon: 'announcement',
          color
        })
      },
      listen__image_view__onstatechange: function (data) {
        if (data.coord != undefined)
          this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
        if (data.zoom != undefined)
          this.state.currentFrameState.zoom = data.zoom
        if (data.voi != undefined)
          this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
        const imageView2 = this.$refs['image-view2']
        if (imageView2 != undefined) {
          imageView2.tostatechange(data)
        }
      },
      listen__image_view__onstatechange2: function (data) {
        if (data.coord != undefined)
          this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
        if (data.zoom != undefined)
          this.state.currentFrameState.zoom = data.zoom
        if (data.voi != undefined)
          this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
        const imageView1 = this.$refs['image-view1'];
        if (imageView1 != undefined) {
          imageView1.tostatechange(data)
        }
      },
      listen__result__download: function () {
        const Vue = this
        try {
          const name = Vue.compositionFileData.files[0].name
          var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(Vue.jsonData))
          var downloadAnchorNode = document.createElement('a')
          downloadAnchorNode.setAttribute("href", dataStr)
          downloadAnchorNode.setAttribute("download", name + "__.json")
          document.body.appendChild(downloadAnchorNode)
          downloadAnchorNode.click()
          downloadAnchorNode.remove()
  
          var link = document.createElement('a');
          link.download = name + "__.jpg";
          link.href = URL.createObjectURL(
            new Blob([Vue.predJpegImage], { type: 'image/jpeg' })
          );
          link.click();
        } catch (err) {
          Vue.$q.notify({
            message: '인식결과 다운로드에 실패하였습니다.',
            icon: 'announcement',
            color: 'purple'
          })
        }
      },
      listen__ip_dialog__done: async function (data) {
        const Vue = this
        if (Vue.frameData1.id != data.id) {
          Vue.listen__x__onfilechange(
            PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
            {keepFrameData0: true}
          )
        }
      },
      beforeEnter: function (el) {
        el.style.opacity = 0
      },
      enter: function (el, done) {
        var delay = el.dataset.index * 150
        setTimeout(function () {
          Velocity(
            el,
            { opacity: 1 },
            { complete: done }
          )
        }, delay)
      },
      leave: function (el, done) {
        var delay = el.dataset.index * 150
        setTimeout(function () {
          Velocity(
            el,
            { opacity: 0 },
            { complete: done }
          )
        }, delay)
      },
      clearData: function (keepFrameData0) {
        if (keepFrameData0 == false) {
          this.frameData0 = {
            _uid: MISC.getUuid4(),
            _empty: true
          }
        }
        this.frameData1 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
        this.frameData2 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
  
        this.pred = []
        this.predJpegImage = null
      },
      updateTagging() {
        this.$refs['image-view1'].updateTagging()
        if (this.$refs['image-view2'] != undefined)
          this.$refs['image-view2'].updateTagging()
      },
      recognitionHwr(file, options) {
        const Vue = this
        
        const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
        Vue.clearData(keepFrameData0)
  
        Vue.showLayer('이미지를 읽는 중...');
        
        MISC.doubleRaf(async () => {
          let image
          
          let tokens = file.name.split('.');
          let ext = tokens[tokens.length - 1].toLowerCase();
          try {
            image = await PARSE.parseImage(file, ext);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
            return
          }
          let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);
  
          Vue.showLayer('인식 중...');
          let ret = {};
          try {
            ret = await recognize.recognizeHWR(file);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'red', message: err})
            return
          }
  
          if (keepFrameData0 == true) {
            Vue.frameData1 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
          } else {
            Vue.frameData0 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
            Vue.frameData1 = Vue.frameData0
          }
  
          let cornerstoneImage2 = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, ret.image.pixelData, ret.image.width, ret.image.height);
          Vue.frameData2 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage: cornerstoneImage2,
            _empty: false
          };
          Vue.state.tab = "image"
          Vue.pred = ETC.sorted(ret.pred)
          Vue.jsonData = ret.data
          Vue.predJpegImage = ret.image_jpeg
          Vue.hidingLayer()
        });
      },
      recognitionOcr(file, options) {
        const Vue = this
  
        const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
        Vue.clearData(keepFrameData0)
  
        Vue.showLayer('이미지를 읽는 중...');
        
        MISC.doubleRaf(async () => {
          let image
          let tokens = file.name.split('.');
          let ext = tokens[tokens.length - 1].toLowerCase();
          try {
              image = await PARSE.parseImage(file, ext);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
            return
          }
          let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);
  
          Vue.showLayer('인식 중...');
          let ret = {};
          try {
            ret = await recognize.recognize(file);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'red', message: err})
            return
          }
          
          if (keepFrameData0 == true) {
            Vue.frameData1 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
          } else {
            Vue.frameData0 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
            Vue.frameData1 = Vue.frameData0
          }
          
          let cornerstoneImage2 = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, ret.image.pixelData, ret.image.width, ret.image.height);
          Vue.frameData2 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage: cornerstoneImage2,
            _empty: false
          };
          Vue.state.tab = "image"
          Vue.pred = ETC.sorted(ret.pred)
          Vue.jsonData = ret.data;
          Vue.predJpegImage = ret.image_jpeg
          Vue.hidingLayer()
        });
      },
      recognitionOcrDocument(file, options) {
        const Vue = this
        
        const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
        Vue.clearData(keepFrameData0)
  
        Vue.showLayer('이미지를 읽는 중...');
        
        MISC.doubleRaf(async () => {
          let image
          
          let tokens = file.name.split('.');
          let ext = tokens[tokens.length - 1].toLowerCase();
          try {
            image = await PARSE.parseImage(file, ext);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
            return
          }
          let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);
  
          Vue.showLayer('인식 중...');
          let ret = {};
          try {
            ret = await recognize.recognizeDocument(file);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'red', message: err})
            return
          }
          
          if (keepFrameData0 == true) {
            Vue.frameData1 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
          } else {
            Vue.frameData0 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
            Vue.frameData1 = Vue.frameData0
          }
          
          let cornerstoneImage2 = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, ret.image.pixelData, ret.image.width, ret.image.height);
          Vue.frameData2 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage: cornerstoneImage2,
            _empty: false
          };
          Vue.state.tab = "image"
          Vue.pred = ETC.sorted(ret.pred)
          Vue.jsonData = ret.data;
          Vue.predJpegImage = ret.image_jpeg
          Vue.hidingLayer()
        });
      },
      getAddress: function () {
        const Vue = this
        return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
      },
      toggleThresholdProbability: function () {
        const Vue = this
        // console.log(`caller: ${caller}`)
        
        if (Vue.state.slider.thresholdProbability.active == true) {
          for (let item of Vue.searchTexts) {
            if (item.prob >= Vue.state.slider.thresholdProbability.value)
              item.highlight = true
            else
              item.highlight = false
          }
        } else {
          for (let item of Vue.searchTexts) {
            item.highlight = false
          }
        }
      }
    },
    computed: {
      texts: function () {
        return this.pred
      },
      searchTexts: function () {
        if (this.texts.length == 0)
          return [];
        if (this.state.searchText == null || this.state.searchText.length == 0) {
          return this.texts.slice();
        } else {
          let searchTexts = [];
          for (let item of this.texts) {
            if (item.text.indexOf(this.state.searchText) != -1)
              searchTexts.push(item);
          }
          return searchTexts;
        }
      },
      title: function () {
        const Vue = this
        if (Vue.recognitionType == 'ocr')
          return 'OCR - Natural scene'
        else if (Vue.recognitionType == 'hwr')
          return 'OCR - 필기'
        else if (Vue.recognitionType == 'ocr-doc')
          return 'OCR - 문서(A4)'
        else
          return ''
      },
      healthCheckFunction: function () {
        return {
          ocr: recognize.recognize,
          hwr: recognize.recognizeHWR,
          ocrDoc: recognize.recognizeDocument
        }
      },
      sliderThresholdProbabilityValue: function () {
        const Vue = this
        return Vue.state.slider.thresholdProbability.value.toFixed(4)
      },
      isDev() {
        return ETC.isDev()
      }
    },
    watch: {
      searchTexts: function () {
        const Vue = this
        for (let item of Vue.texts) {
          const idx = Vue.searchTexts.findIndex((v) => item.id == v.id);
          if (idx != -1) {
            for (let row of Vue.pred) {
              if (row.id == item.id) {
                row['active'] = true
              }
            }
          } else {
            for (let row of Vue.pred) {
              if (row.id == item.id) {
                row['active'] = false
              }
            }
          }
        }
        Vue.toggleThresholdProbability()
        Vue.updateTagging()
      },
      'state.currentFrameToolOption.lineColor': function (value) {
        this.$refs['image-view1'].setToolOption('lineColor', value)
        if (this.$refs['image-view2'] != undefined)
          this.$refs['image-view2'].setToolOption('lineColor', value)
      },
      'state.currentFrameToolOption.lineHighlightColor': function (value) {
        this.$refs['image-view1'].setToolOption('lineHighlightColor', value)
        if (this.$refs['image-view2'] != undefined)
          this.$refs['image-view2'].setToolOption('lineHighlightColor', value)
      },
      'state.currentFrameToolOption.lineWidth': function (value) {
        this.$refs['image-view1'].setToolOption('lineWidth', value)
        if (this.$refs['image-view2'] != undefined)
          this.$refs['image-view2'].setToolOption('lineWidth', value)
      },
      recognitionType: function () {
        const Vue = this
        Vue.$refs['health-check'].listen__healthcheck__onclick()
      },
      'state.slider.thresholdProbability.value': async function () {
        const Vue = this
        Vue.state.slider.thresholdProbability.active = true
        Vue.toggleThresholdProbability('state.slider.thresholdProbability.value')
        this.updateTagging()
      },
      'state.slider.thresholdProbability.active': function () {
        const Vue = this
        Vue.toggleThresholdProbability('state.slider.thresholdProbability.active')
        this.updateTagging()
      },
    },
    async mounted () {
      const Vue = this
      Vue.$refs['health-check'].listen__healthcheck__onclick()
    },
    created() {
      if ('ocr' == this.recognitionType) {
        this.sampleImages.push({name: '범용-001',url: `${process.env.VUE_APP_URL}/api/image/Genaral_001.png`})
        this.sampleImages.push({name: '범용-002',url: `${process.env.VUE_APP_URL}/api/image/Genaral_002.png`})
        this.sampleImages.push({name: '범용-003',url: `${process.env.VUE_APP_URL}/api/image/Genaral_003.png`})
        this.sampleImages.push({name: '범용-004',url: `${process.env.VUE_APP_URL}/api/image/Genaral_004.jpg`})
        this.sampleImages.push({name: '영수증-001',url: `${process.env.VUE_APP_URL}/api/image/RECEIPT_0001.jpg`})
        this.sampleImages.push({name: '사원증-001',url: `${process.env.VUE_APP_URL}/api/image/Worker_0001.jpg`})
        this.sampleImages.push({name: '보그-001',url: `${process.env.VUE_APP_URL}/api/image/VOGUE_000.jpg`})
        this.sampleImages.push({name: '헬스-001',url: `${process.env.VUE_APP_URL}/api/image/MENS_HEALTH_001.jpg`})
      }
      else if ('ocr-doc' == this.recognitionType) {
        this.sampleImages.push({name: '사업자등록증',url: `${process.env.VUE_APP_URL}/api/image/a28e34cf-5045-4e5d-9e96-8966448f3ab9.png`})
        this.sampleImages.push({name: '제무제표',url: `${process.env.VUE_APP_URL}/api/image/952b0570-dd75-11ec-8a26-d8bbc1513c10.jpg`})
        this.sampleImages.push({name: '가족관계증명서',url: `${process.env.VUE_APP_URL}/api/image/76a9eb3b-1dd7-46ac-a2fa-b505ada09471.jpg`})
        this.sampleImages.push({name: '제품설명서',url: `${process.env.VUE_APP_URL}/api/image/ProductManual_000.jpg`})
        this.sampleImages.push({name: '계좌 입금거래 약정서',url: `${process.env.VUE_APP_URL}/api/image/hwr-a4-0001.jpg`})
        this.sampleImages.push({name: '공탁금 계좌 입금 신청서',url: `${process.env.VUE_APP_URL}/api/image/hwr-a4-0002.jpg`})
      } else if ('hwr' == this.recognitionType) {
        this.sampleImages.push({name: '필기 1',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_001.png`})
        this.sampleImages.push({name: '필기 2',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_002.png`})
        this.sampleImages.push({name: '필기 3',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_003.jpg`})
        this.sampleImages.push({name: '필기 4',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_004.jpg`})
        this.sampleImages.push({name: '필기 5',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_005.jpg`})
        this.sampleImages.push({name: '필기 6',url: `${process.env.VUE_APP_URL}/api/image/HandwritingOcr_006.jpg`})
      }
    }
  }
  </script>
  
  <style scoped>
  @media (max-width: 1100px) {
    .image-tool-btn-group {
      display: none !important;
    }
  }
  </style>
  
  <style>
  .slider-theshold-probability {
    margin-top: 4px !important;
  }
  .slider-theshold-probability > div {
    min-height: 18px;
  }
  </style>